<template>
  <span v-if="situacao" :class="textColorClass">
    <v-icon right :class="`pb-1 ${textColorClass}`">mdi-circle-medium</v-icon>
    {{ description }}
  </span>
</template>

<script>
import { SituacaoAprovacao } from 'px-business-components';

const TEXT_COLOR_MAP = {
  APROVADO: 'green--text text--darken-3',
  PENDENTE: 'yellow--text text--darken-3',
  RECUSADO: 'error--text',
};

export default {
  props: {
    situacao: String,
  },
  computed: {
    description() {
      if (!this.situacao) {
        return '';
      }
      return SituacaoAprovacao.keys[this.situacao].description;
    },
    textColorClass() {
      return TEXT_COLOR_MAP[this.situacao];
    },
  },
};
</script>
